/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * For the role PATCH on users.
 * @export
 * @interface PatchedOrganisationUserRolePatch
 */
export interface PatchedOrganisationUserRolePatch {
  /**
   *
   */
  roles?: Array<string>;
}

/**
 * Check if a given object implements the PatchedOrganisationUserRolePatch interface.
 */
export function instanceOfPatchedOrganisationUserRolePatch(
  value: object
): value is PatchedOrganisationUserRolePatch {
  return true;
}

export function PatchedOrganisationUserRolePatchFromJSON(
  json: any
): PatchedOrganisationUserRolePatch {
  return PatchedOrganisationUserRolePatchFromJSONTyped(json, false);
}

export function PatchedOrganisationUserRolePatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedOrganisationUserRolePatch {
  if (json == null) {
    return json;
  }
  return {
    roles: json["roles"] == null ? undefined : json["roles"],
  };
}

export function PatchedOrganisationUserRolePatchToJSON(
  json: any
): PatchedOrganisationUserRolePatch {
  return PatchedOrganisationUserRolePatchToJSONTyped(json, false);
}

export function PatchedOrganisationUserRolePatchToJSONTyped(
  value?: PatchedOrganisationUserRolePatch | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    roles: value["roles"],
  };
}
